<template>
  <div>
    <nav
      v-bind:class="['navbar navbar-expand-lg', {
        'navbar-dark' : theme === 'dark' ,
        'navbar-light' : theme === 'light' ,
        'open' : this.navOpen
      }]">
      <div class="container">
        <button v-bind:class="['navbar-toggler', {'active' : this.navOpen }]" type="button" v-on:click="toggleNav()">
          <span></span>
        </button>
        <div class="row">
          <div class="col-auto" v-if="showLogo">
            <ul class="navbar-nav pr-0">
              <li class="nav-item">
                <router-link to="/" class="navbar-brand" title="Link: Home">
                  <img v-if="theme === 'dark'" src="../assets/logo-symbol@3x.png"
                       alt="Image: Vintrigue Logo Alt"/>
                  <img v-if="theme === 'light'" src="../assets/logo-symbol-dark@3x.png"
                       alt="Image: Vintrigue Logo Alt"/>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="col nav-wrapper">
            <div v-bind:class="['navbar-collapse', {'collapse' : !this.navOpen }]">
              <ul class="navbar-nav">
                <li class="nav-item">
                  <router-link to="/products" class="nav-link" title="Link: Products">Products</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/producers" class="nav-link" title="Link: Producers">Producers</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/about" class="nav-link" title="Link: About us">About us</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/contact" class="nav-link" title="Link: Contact">Contact</router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col">
            <ul class="navbar-nav justify-content-end">
              <li class="nav-item ">
                <router-link to="/favourites"
                             v-bind:class="['nav-link', { 'text-light' : favouriteTheme === 'dark' , 'text-dark' : favouriteTheme === 'light' }]"
                             title="Link: Favourites">Favourites ({{ $root.basket && $root.basket.products ?
                  $root.basket.products.length : '0'}})
                </router-link>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </nav>
  </div>
</template>

<script>
  export default {
    name: 'Navigation',
    props: {
      showLogo: {
        type: Boolean,
        default: true
      },
      theme: {
        type: String,
        default: 'dark'
      },
      favouriteTheme: {
        type: String,
        default: 'dark'
      },
    },
    data() {
      return {
        navOpen: false,
      };
    },
    methods: {
      toggleNav: function () {
        this.navOpen = !this.navOpen;
      }
    }
  }
</script>
